export const FETCH_DEFAULT_NETWORK_CODE_LIST = 'FETCH_DEFAULT_NETWORK_CODE_LIST';

export function fetchDefaultNetworkCodeList() {
    return {
        type: FETCH_DEFAULT_NETWORK_CODE_LIST,
    };
}
